import React, { useState, useCallback, useMemo, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { svgSprite } from '../../../../../hybrid/wrappers';
import FormTextArea from '../../../../../widgets/form/components/form-textarea/FormInputArea';
import SearchWindow from '../../../../searchWindow/SearchWindow';
import { API_SERVER_URL, useWidgetTranslates } from '../../../../../common/utils/utils';
import UserContext from '../../../../../common/utils/getContext';
import FormInput from '../../form-input/FormInput/FormInput';
import { useWindowDimensions } from '../../../../../common/utils/windowDimensions';
import T, { t } from '../../../../../common/components/T';
import { getData } from '../../../../../common/utils/router';
import css from './SelectDataWidget.module.scss';
import classnames from 'classnames';
import { generateCompStylers } from '../../../../../common/utils/styles';
import Display from '../../../../../common/components/Display';

const Wrapper = (props) => {
    if (props?.helpButtons) return <div {...props}>{props.children}</div>;
    return <>{props.children}</>;
};

const StatementUserWidget = (props) => {
    const { attribute, handlers = {}, compStyle, value, setFormData, customData = {}, initValue } = props;
    const { userToken, setAlertData, lang } = useContext(UserContext);
    const [val, setVal] = useState(value);
    const [count, setCount] = useState(0);
    const [showSponsor, setShowSponsor] = useState(false);
    const widthDimensions = useWindowDimensions();
    const screenWidth = useMemo(() => widthDimensions <= 768, [widthDimensions]);

    const getUserData = useCallback(
        async (data) => {
            setAlertData(false);
            if (customData?.transformResultData) {
                setFormData(attribute, customData?.transformResultData(data));
            } else {
                setFormData(attribute, data);
            }
            if (!customData?.url && !customData?.hideUserInfo) {
                setVal({ data, id: data?.id });
            } else {
                setVal(customData?.transformResultData ? customData?.transformResultData(data) : data);
            }
            if (handlers?.onBlur) {
                handlers.onBlur(attribute, data);
            }
            setShowSponsor(false);
        },
        [setAlertData, customData, handlers, setFormData, attribute]
    );

    useEffect(() => {
        if (value?.id && !customData?.url) {
            (async () => {
                const userInfo = await getData(`/api/v1/user/partners/${value.id}`, userToken, lang);
                if (userInfo && userInfo?.data) {
                    setVal(userInfo.data);
                }
            })();
        }
    }, [customData?.url, lang, userToken, value?.id]);

    useEffect(() => {
        setCount((pre) => ++pre);
    }, [initValue?.users]);

    useEffect(() => {
        if (value?.id && customData?.loading === false && customData?.url) {
            setVal(value);
        }
    }, [customData, value]);

    const transl = useWidgetTranslates('form');
    const { stylers, classes } = generateCompStylers(compStyle);
    const setFunc = useCallback(
        (attr, v) => {
            setFormData(attr, v);
        },
        [setFormData]
    );
    return (
        <>
            <div style={stylers.wrapper} className={classnames(css.formGroup, classes.wrapper)}>
                <Wrapper helpButtons={customData?.helpButtons} className={classnames(css.formSelectDataButtonsInputWrap)}>
                    <div>
                        <div
                            className={classnames(css.chooseBtn)}
                            onClick={() => {
                                setShowSponsor(true);
                            }}
                        >
                            {svgSprite('user', {
                                style: {
                                    height: '16px'
                                }
                            })}
                        </div>
                        {val?.data?.name ? (
                            <div className={classnames(css.chooseUserInfo)}>
                                {val.data.name} {val?.data?.country?.name ? `(${val?.data?.country?.name})` : null}
                            </div>
                        ) : null}

                        <div key={count}>
                            {val?.id ? (
                                <div className={classnames(css.accountList)}>
                                    <div>
                                        <div className={classnames(css.accountListTitle)}>
                                            <T
                                                vars={{ amount: val?.data?.main_account?.balance_formatted }}
                                                textName='users-statement-Account-main-title'
                                                defaultStr='Основной (${amount})'
                                            />
                                        </div>
                                        <FormInput
                                            attribute={`main_account`}
                                            compStyle={{
                                                wrapper: { className: css.inputMb },
                                                info: {
                                                    wrapper: {
                                                        'align-items': 'center'
                                                    }
                                                }
                                            }}
                                            errors={
                                                Number(initValue?.main_account) > initValue?.users?.main_account?.balance
                                                    ? [
                                                          t(
                                                              'Form-error_sum-less',
                                                              'Недостаточно средств.',
                                                              'widget',
                                                              transl,
                                                              'form'
                                                          )
                                                      ]
                                                    : []
                                            }
                                            typeField={'number'}
                                            textBottom={
                                                initValue?.user_id?.rate && initValue?.main_account ? (
                                                    <Display
                                                        type='value'
                                                        data={{
                                                            value: initValue?.user_id?.rate * initValue?.main_account || '0.00',
                                                            currency: { symbol: initValue?.user_id?.finance_currency?.symbol }
                                                        }}
                                                    />
                                                ) : (
                                                    false
                                                )
                                            }
                                            setFormData={setFunc}
                                            title={{
                                                body: <T textName='users-statement-Account-out' defaultStr='Вывести' />
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <div className={classnames(css.accountListTitle)}>
                                            <T
                                                vars={{ amount: val?.data?.bonus_account?.balance_formatted }}
                                                textName='users-statement-Account-bonus-title'
                                                defaultStr='Бонусный (${amount})'
                                            />
                                        </div>
                                        <FormInput
                                            attribute={`bonus_account`}
                                            compStyle={{
                                                wrapper: { className: css.inputMb },
                                                info: {
                                                    wrapper: {
                                                        'align-items': 'center'
                                                    }
                                                }
                                            }}
                                            errors={
                                                Number(initValue?.bonus_account) > initValue?.users?.bonus_account?.balance
                                                    ? [
                                                          t(
                                                              'Form-error_sum-less',
                                                              'Недостаточно средств.',
                                                              'widget',
                                                              transl,
                                                              'form'
                                                          )
                                                      ]
                                                    : []
                                            }
                                            typeField={'number'}
                                            setFormData={setFunc}
                                            textBottom={
                                                initValue?.user_id?.rate && initValue?.bonus_account ? (
                                                    <Display
                                                        type='value'
                                                        data={{
                                                            value: initValue?.user_id?.rate * initValue?.bonus_account || '0.00',
                                                            currency: { symbol: initValue?.user_id?.finance_currency?.symbol }
                                                        }}
                                                    />
                                                ) : (
                                                    false
                                                )
                                            }
                                            title={{
                                                body: <T textName='users-statement-Account-out' defaultStr='Вывести' />
                                            }}
                                        />
                                        <FormTextArea
                                            compStyle={{
                                                wrapper: { className: css.formControlTextare }
                                            }}
                                            attribute='comment'
                                            disabled={false}
                                            title={{ body: <T textName='AdminStatement_comment' defaultStr='Примечание' /> }}
                                            setFormData={setFunc}
                                            rows={3}
                                        />
                                    </div>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </Wrapper>
            </div>
            {showSponsor && (
                <SearchWindow
                    input={customData?.modalInput || {}}
                    transformSearchData={customData?.transformSearchData || null}
                    thead={customData?.thead || null}
                    portalClass={!screenWidth ? 'modal' : 'modalBottom'}
                    closeModal={setShowSponsor}
                    sendData={{
                        url: customData?.url || `${API_SERVER_URL}/api/v1/admin/work-table/statements/search-users`
                    }}
                    title={customData?.modalTitle || t('Form-ChooseUserSt', 'Выбрать Пользователя', 'widget', transl, 'form')}
                    customData={{ ...customData, buttonNotShow: true }}
                    gridHandlers={{
                        tr: {
                            onClick: async (rowData) => {
                                await getUserData(rowData);
                            }
                        }
                    }}
                    customStyle={{
                        ...compStyle,
                        searchWindowWrapper: !screenWidth ? { width: '1184px' } : {}
                    }}
                    fastSearch={true}
                />
            )}
        </>
    );
};
StatementUserWidget.propTypes = {
    attribute: PropTypes.string,
    handlers: PropTypes.object,
    compStyle: PropTypes.object,
    value: PropTypes.object,
    setFormData: PropTypes.func,
    customData: PropTypes.object,
    variation: PropTypes.string,
    title: PropTypes.object,
    placeholder: PropTypes.node
};
export default StatementUserWidget;
